export const STATUS_VALUES = ['active', 'inactive'] as const;

export type Status = (typeof STATUS_VALUES)[number];

export const STATUS_LABELS: Record<Status, string> = {
  active: 'Active',
  inactive: 'Inactive',
};
